import { useCallback } from 'react';
import * as yup from 'yup';
import { useSearchParams } from '~/components/Route';

export type CategoryType = 'all' | 'notice' | 'event' | 'winners';

export type NoticeParams = {
  category: CategoryType;
};
export const schema = yup.object().shape({
  category: yup.string().oneOf(['all', 'notice', 'event', 'winners']).default('all'),
});
export const useNoticeParams = () => {
  const converter = useCallback((params) => schema.castOrDefault(params), []);
  return useSearchParams<NoticeParams>({ converter });
};
